<template>
  <aside class="country-side-bar">
    <div class="country-side-bar__super-title">
      {{ $t("general.labels.developedIn") }}
    </div>

    <SDGPanelContent
      class="country-side-bar__panel"
      :country="$t(`countryMapData.${countryCode}.name`)"
      :sectors="$tm(`countryMapData.${countryCode}.sectors`)"
      :text="cardSubscript"
      :columnLabels="$tm('gemeral.labels.SDGLegend')"
    />

    <ButtonScroll
      class="country-side-bar__scroll-btn"
      v-if="smallscreen"
      @onScroll="scrollDown"
    />
  </aside>
</template>

<script setup>
import SDGPanelContent from "../charts/map/SDGPanelContent.vue";
import ButtonScroll from "./ButtonScroll.vue";

defineProps({
  smallscreen: Boolean,
  cardSubscript: String,
  countryCode: String,
});

function scrollDown() {
  const firstContentEl = document.getElementById("country-content");

  if (firstContentEl) {
    firstContentEl.scrollIntoView({ behavior: "smooth" });
  }
}
</script>

<style lang="scss" scoped>
.country-side-bar {
  color: var(--white-100);
  background-image: var(--diag-gradient-alleanze-per-lo-sviluppo);
  padding: var(--modal-padding);

  .desktop &,
  .large & {
    height: 100%;
    min-width: toRem(450);
  }

  .mobile &,
  .tablet & {
    --column-1-width: 100%;

    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    margin-top: -0.4rem;
  }

  &__super-title {
    @include dida-xs;

    font-style: italic;
    margin-bottom: 0.25rem;
  }

  &__panel {
    padding-right: 3vw;
  }

  &__scroll-btn {
    margin-top: 0.5rem;
  }
}
</style>
